/**
 * CSORegisterCatalogService - Helper for active (non-invalidated) CSO registers.
 */
import CSORegisterService from '@/shared/services/cso/CSORegisterService';

class CSORegisterCatalogService {
  /**
   * @returns {Promise<Array>} Active CSO registers
   */
  async getActive() {
    const registers = await CSORegisterService.getAllCSORegisters();
    return (registers || []).filter((reg) => !reg?.invalidated);
  }
}

const instance = new CSORegisterCatalogService();
export default instance;
